import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t@media not all and (min-resolution: 0.001dpcm) {\n\t\t\t@supports (-webkit-appearance: none) {\n\t\t\t\t", "\n\t\t\t}\n\t\t}\n\t"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t@-moz-document url-prefix() {\n\t\t\t", ";\n\t\t}\n\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t@media screen and (-ms-high-contrast: active),\n\t\t\t(-ms-high-contrast: none) {\n\t\t\t", ";\n\t\t}\n\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '../style-system';
/**
 * @param {TemplateStringsArray} strings
 * @param  {import('create-emotion').Interpolation[]} interpolations
 */

export function ieOnly(strings) {
  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var interpolatedStyles = css.apply(void 0, [strings].concat(interpolations));
  return css(_templateObject(), interpolatedStyles);
}
/**
 * @param {TemplateStringsArray} strings
 * @param  {import('create-emotion').Interpolation[]} interpolations
 */

export function firefoxOnly(strings) {
  for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    interpolations[_key2 - 1] = arguments[_key2];
  }

  var interpolatedStyles = css.apply(void 0, [strings].concat(interpolations));
  return css(_templateObject2(), interpolatedStyles);
}
/**
 * @param {TemplateStringsArray} strings
 * @param  {import('create-emotion').Interpolation[]} interpolations
 */

export function safariOnly(strings) {
  for (var _len3 = arguments.length, interpolations = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    interpolations[_key3 - 1] = arguments[_key3];
  }

  var interpolatedStyles = css.apply(void 0, [strings].concat(interpolations));
  return css(_templateObject3(), interpolatedStyles);
}